import { createContext, useContext } from "react";

import { PlayerEmbedParams } from "../types/common";

export const EmbedParametersContext = createContext<
  PlayerEmbedParams | undefined
>(undefined);

export const useEmbedParametersContext = (): PlayerEmbedParams => {
  const context = useContext(EmbedParametersContext);
  if (context === undefined) {
    throw new Error("EmbedParametersContext not found");
  }
  return context;
};
